var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9V11M8 13V11M8 11H6M8 11H10M14 11H13.99M17 11H16.99M3 17V10C3 7.23858 5.23858 5 8 5H16C18.7614 5 21 7.23858 21 10V17V17C21 18.631 19.2792 19.6881 17.8244 18.951L12 16L6.17231 18.9498C4.71865 19.6856 3 18.6293 3 17V17Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.b7ecba787d9c382b194a807605912edd.svg";
export { ForwardRef as ReactComponent };